<template>
  <div class="content">
    <TopLayoutClient :title="'Dashboard de Cortes'" />
    <div class="row mt-4">
      <div class="col-md-8">
        <div class="quad px-3 py-2">
          <div class="row mb-3"></div>
          <div class="table-responsive">
            <table class="table">
              <thead style="background-color: #560382">
                <tr style="color: #b8d941">
                  <th scope="col text-center">Pedido</th>
                  <th scope="col text-center">Corte</th>
                </tr>
              </thead>
              <tbody v-if="
                !state.loading && state.pedidos && state.pedidos.length > 0
              ">
                <tr v-for="pedido in state.pedidos" :key="pedido.id">
                  <td class="d-flex gap-3 text-wrap" style="width:80%;">
                    <div class="wrapper_product_item product_item">
                      <div style="width: 100%;">
                        <div class="cliente_padding">
                          <div>{{ pedido.cod_marketplace }}</div>
                          <div>{{ pedido.nome_cliente }}</div>
                          <div v-if="state.pedido_selecionado.id == pedido.id">
                            <table class="table" v-if="state.itens.length > 0">
                              <thead>
                                <th style="width:80%">Produto</th>
                                <th>Quantidade</th>
                              </thead>
                              <tbody>
                                <tr v-for="item in state.itens" :key="item.id">
                                  <td
                                    style="width:80%; word-break: break-word; white-space: normal; display: flex; gap:10px">
                                    <img :src="item.produto.imagem" />
                                    {{ item.produto.nome }}
                                  </td>
                                  <td style="text-align: center;">
                                    {{ item.quantidade }}
                                  </td>
                                  <td style="text-align: center;">
                                    <button class="btn btn-primary" @click="modalProdutoSelecionado(item)"><i
                                        class="bi bi-check" style="font-size: 20;"></i></button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <div>

                            </div>
                          </div>


                        </div>
                      </div>
                    </div>
                  </td>

                  <td>
                    <div style="position: relative; cursor: pointer">
                      <button type="button" class="btn btn-primary" @click="selecionarPedido(pedido)"
                        :disabled="state.ext_pedido_selecionado">Selecionar</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="quad px-3 py-2">
          <div v-if="state.pedido_selecionado">
            Pedido {{ state.pedido_selecionado.cod_marketplace }}
          </div>
          <!-- v-if="selectedIds.length > 0"  -->
          <div v-if="state.pedido_selecionado.id" class="read-products-section flex-shrink-0">
            <h6>Produtos Lidos</h6>
            <table class="table table-sm table-hover custom-table w-100" style="table-layout: fixed;">
              <thead>
                <tr>
                  <th style="width: 70%;padding:0;">Produto</th>
                  <th style="width: 20%;padding:0; text-align: center;">Preço</th>
                  <th style="width: 10%;padding:0; text-align: center;">Qtd</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in state.itens_pedido" :key="item.id">
                  <td style="width: 70%; padding:0">
                    <div class="product-cell d-flex gap-3 text-wrap align-items-start">
                      <img style="height: au;" :src="item.produto?.imagem || ''" alt="Produto" class="product-image" />
                      {{ item.produto?.nome || "" }}
                    </div>

                  </td>
                  <td style="width: 20%; padding:0;text-align: center;">
                    R$
                    {{
                      item.produto?.preco
                        ? item.produto.preco.toFixed(2)
                        : "0,00"
                    }}
                  </td>
                  <td style="width: 10%; padding:0; text-align: center;">{{ item.quantidade }}</td>
                </tr>
              </tbody>
            </table>
            <div>
              <button class="btn btn-primary" @click="handleSalvarPedido()">Salvar</button>
              <button class="btn btn-primary" @click="cancelar()">Cancelar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ModalCorte :open="state.modalOpen" @close="state.modalOpen = false" :pedido="state.pedido_selecionado"
    :item="state.item_selecionado" v-model:readProductIds="state.produtos_lidos" @confirm="addProdutoSelecionado"
    width="800px" v-if="state.pedido_selecionado" />
</template>

<script>
import TopLayoutClient from "../../layout/compontens/TopLayoutClient.vue";
import { reactive, onMounted, onBeforeUnmount, ref, computed } from "vue";
const tooltipRef = ref(null);

import ModalCorte from "../Modal/ModalCorte.vue";

import api from "../../services";
const vendas = api.vendas;
const produtos = api.produtos;

import { useStorage } from "vue3-storage";

export default {
  components: {
    TopLayoutClient,
    ModalCorte,
  },
  setup() {
    const state = reactive({
      loading: true,
      pesquisa_corte: "",
      n_por_paginas: 10,
      n_pagina: 1,
      qtd_paginas: 1,
      cortes: [],
      cliente: "",
      loja: "",
      quantidadeLida: null,
      codigoItem: "",
      quantidadeItens: 1,
      produtosPacotes: [],
      produtosLidos: [],
      totalProdutosLidos: 0,
      quantidadeTotal: 0,
      itens: [],
      itens_pedido: [],
      modalOpen: false,
      pedido_selecionado: { itens: [] },
      readProductIdsMap: reactive({}),
      ext_pedido_selecionado: false,
      item_selecionado: { produto: {} }
    });

    const storage = useStorage();
    var token = storage.getStorageSync("cliente_token");
    const colaborador_id = storage.getStorageSync("colaborador_id");

    async function handleSalvarPedido() {
      const pedidoId = state.pedido_selecionado.id;


      await vendas.salvarProdutosLidos({
        token,
        pedido_id: pedidoId,
        colaborador_id,
        itens_pedido: state.itens_pedido
      }).then(() => {
        state.pedido_selecionado = {};
        state.itens = [];
        state.itens_pedido = [];
        state.ext_pedido_selecionado = false;
        state.pedidos = state.pedidos.filter(pedido => pedido.id !== pedidoId);
      }).catch(error => {
        console.error("Erro ao salvar produtos lidos:", error);
        alert("Erro ao salvar produtos lidos.");
      })

    }

    async function fetchPacotesDoDia() {
      try {
        const { data } = await produtos.pacotesDoDia({ token });

        const uniquePedidosMap = new Map();
        data.forEach((pedido) => {
          const clienteKey = pedido.nome_cliente?.trim().toLowerCase() || pedido.id;
          if (!uniquePedidosMap.has(clienteKey)) {
            uniquePedidosMap.set(clienteKey, pedido);
          }
        });
        state.pedidos = Array.from(uniquePedidosMap.values());

        const produtosTransformados = data.flatMap((pedido) => {
          return pedido.itens.map((item) => ({
            id: item.id,
            nome: item.produto?.nome || "",
            descricao: item.produto?.descricao || "",
            imagem: item.produto?.imagem || "",
            codigo: item.produto?.sku || "",
            lidos: 0,
            total: item.quantidade || 0,
            pedido: {
              nome_cliente: pedido.nome_cliente || "",
              loja: pedido.loja || "",
              tipo_entrega: pedido.tipo_entrega || "",
              marketplace: pedido.marketplace || "",
              cod_marketplace: pedido.cod_marketplace || "",
            },
          }));
        });

        state.produtosPacotes = produtosTransformados;
        calculateTotals();
      } catch (error) {
        console.error("Error fetching pacotes do dia:", error);
      }
    }

    function modalProdutoSelecionado(itemSelecionado) {
      state.modalOpen = true;
      state.item_selecionado = itemSelecionado;
    }

    function addProdutoSelecionado(itemSelecionado) {
      const id_item_selecionado = itemSelecionado.id;
      //state.itens = state.itens.filter(item => item.id !== id_item_selecionado);
      const itemExistente = state.itens_pedido.find(el => el.produto.id === itemSelecionado.produto.id);

      if (itemExistente) {
        const itemAtualizado = {
          ...itemExistente,
          quantidade: parseInt(itemExistente.quantidade) + 1
        };
        const novaLista = state.itens_pedido
          .filter(item => item.produto.id !== itemSelecionado.produto.id)
          .concat(itemAtualizado);

        state.itens_pedido = novaLista;

        state.itens = state.itens.filter(item => item.id !== id_item_selecionado);
        /*
          // Atualiza quantidade com imutabilidade
          
  
          // Substitui o item na lista
          const novaLista = itens
              .filter(item => item.produto.id !== itemSelecionado.produto.id)
              .concat(itemAtualizado);
  
          setItens(novaLista);
          setItensPedido(itensPedido.filter(item => item.id !== id_item_selecionado));*/
      } else {
        state.itens_pedido.push(itemSelecionado);
      }


      state.itens = state.itens.filter(item => item.id !== id_item_selecionado);
      state.modalOpen = false;

      //setItensPedido(itensPedido.filter(item => item.id !== id_item_selecionado));
      // const itemExistente = state.itens.find(el => el.produto.id === itemSelecionado.produto.id);




    }

    function cancelar() {
      state.ext_pedido_selecionado = false;
      state.pedido_selecionado = {};
      state.itens_pedido = [];
      state.itens = [];
    }

    function selecionarPedido(pedido) {
      state.ext_pedido_selecionado = true;
      state.itens = pedido.itens;
      state.pedido_selecionado = pedido;
    }


    onMounted(() => {
      fetchPacotesDoDia();
      state.loading = false;
      calculateTotals();
      window.addEventListener("keydown", handleKeydown);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("keydown", handleKeydown);
    });

    const resetBtn = ref(null);

    function reiniciar() {
      console.log("Reiniciando...");
      state.produtosPacotes = [
        ...state.produtosPacotes,
        ...state.produtosLidos,
      ];
      state.produtosLidos = [];
      calculateTotals();
    }

    function handleKeydown(e) {
      if (e.altKey && e.key.toLowerCase() === "q") {
        e.preventDefault();
        reiniciar();
      }
    }

    function calculateTotals() {
      state.totalProdutosLidos = state.produtosPacotes.reduce(
        (acc, item) => acc + (item.lidos || 0),
        0
      );
      state.quantidadeTotal = state.produtosPacotes.reduce(
        (acc, item) => acc + (item.total || 0),
        0
      );
    }

    function handleCodigoEnter() {
      const codigoBusca = state.codigoItem.trim().toLowerCase();
      const index = state.produtosPacotes.findIndex(
        (item) => item.codigo.trim().toLowerCase() === codigoBusca
      );
      if (index !== -1) {
        const [produto] = state.produtosPacotes.splice(index, 1);
        state.produtosLidos.push(produto);
        state.codigoItem = "";
        calculateTotals();
      } else {
        alert("Não há um produto com o código informado.");
        state.codigoItem = "";
      }
    }

    function handleModalConfirm(ite) {/*
      console.log("Confirmados:", itensSelecionados);

      if (!state.pedido_selecionado) return;

      state.readProductIdsMap[
        state.pedido_selecionado.id
      ] = itensSelecionados.map((item) => item.id);

      itensSelecionados.forEach((selected) => {
        const exists = state.produtosLidos.some((p) => p.id === selected.id);
        if (!exists) {
          const index = state.produtosPacotes.findIndex(
            (p) => p.id === selected.id
          );
          if (index !== -1) {
            const [produto] = state.produtosPacotes.splice(index, 1);
            state.produtosLidos.push(produto);
          }
        }
      });
      calculateTotals();
      state.modalOpen = false;
      state.pedido_selecionado = null;*/
    }

    return {
      state,
      handleSalvarPedido,
      reiniciar,
      totalProdutosLidos: computed(() => state.produtosLidos.length),
      handleCodigoEnter,
      handleModalConfirm,
      selecionarPedido,
      addProdutoSelecionado,
      modalProdutoSelecionado,
      cancelar
    };
  },
};
</script>

<style scoped>
.content {
  padding: 1rem;
}

.quad {
  background: #ffffff;
  padding: 0.625rem;
  border: solid 0.0625rem #0000000d;
}


td .btn i {
  font-size: 1rem;
  color: #b8d941;
}

td .btn:hover {
  transform: scale(0.95);
}

td .btn:hover i {
  color: #560382;
}

.search {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 0.625rem;
  margin-right: 0.625rem;
  margin-bottom: 1rem;
}

.search input {
  border: none;
  outline: none;
  padding: 0.625rem;
  border-radius: 0 2.8125rem 2.8125rem 0;
  background: #f4f7fe;
}

.search input::placeholder {
  color: #9d9d9d;
}

.btn-primary {
  margin-right: 0.625rem;
}

.search .btn_search {
  border: none;
  outline: none;
  padding: 0.625rem;
  border-radius: 2.8125rem 0 0 2.8125rem;
  background: #f4f7fe;
  color: #9d9d9d;
}

.search .btn_cancelar {
  border: none;
  outline: none;
  padding: 0.4375rem;
  padding-left: 1.875rem;
  margin-left: -1.25rem;
  border-radius: 0 2.8125rem 2.8125rem 0;
  background: #f4f7fe;
  color: #9d9d9d;
}

.action_buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  padding: 1rem 0;
}

.action_buttons button:first-of-type {
  background-color: #fff;
  border: 0.0625rem solid #560382;
  color: #560382;
}

.action_buttons button:first-of-type:hover {
  background-color: #202020;
  color: #fff;
  border: 0.0625rem solid #202020;
}

.action_buttons button:first-of-type:hover span {
  color: #fff;
}

.action_buttons span {
  color: #000;
  opacity: 40%;
  font-size: 0.75rem;
}

.action_buttons button:last-of-type {
  background-color: #560382;
  border: 0.0625rem solid transparent;
  color: #fff;
}

.action_buttons button:last-of-type:hover {
  background-color: #202020;
  border: 0.0625rem solid #202020;
  color: #fff;
}

.action_buttons button {
  border: none;
  border-radius: 0.875rem;
  padding: 0.25rem 1rem;

  transition: 0.15s ease-in-out;
}

.action_buttons button:hover {
  transform: scale(0.98);
}

.wrapper_product_item {
  width: 100%;
  display: flex;
}

.product_item {
  font-size: 0.875rem;
  white-space: normal;
}

.item-code-input {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.scissors-btn {
  padding: 1rem;
  border: none;
  color: #fff;
  background-color: #560382;
  transition: 0.15s ease-in-out;
}

.scissors-btn:hover {
  filter: brightness(1.5);
}

.container_code {
  display: flex;
  justify-content: space-between;
  background-color: #202020;
  color: #fff;
  padding: 0.5rem 0.5rem;
  cursor: pointer;

  transition: 0.2s ease-in-out;
  position: relative;
  overflow: hidden;
  z-index: 0;
  transition: color 0.2s ease-in-out;
}

.container_code>* {
  z-index: 1;
}

.container_code:hover {
  color: #b8d941;
}

.container_code::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background-color: #560382;
  transition: left 0.5s ease-in-out;
}

.container_code:hover::before {
  left: 0;
}

.cliente_padding {
  padding: 10px 0;
}
</style>
